// Cheque payment: mark paid (with confirm + overdraft flow) OR revert to unpaid
// (with two-step stern confirmation, keeping any transfers untouched).
import { toast } from "sonner";
import api from "@/lib/api";

// Low-level: PATCH status=paid, propagates the 409 overdraft flow via a global event.
// Returns true on success, false if handled overdraft, throws on unrelated errors.
export async function payChequeWithGuard({ cheque, tError, reload }) {
  try {
    await api.patch(`/cheques/${cheque.id}`, { status: "paid" });
    reload();
    return true;
  } catch (e) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status === 409 && d?.account_over_balance) {
      window.dispatchEvent(new CustomEvent("malat:cheque-overdraft", { detail: { cheque, overdraft: d, reload } }));
      return false;
    }
    toast.error(tError);
    return false;
  }
}

export async function markChequePaid({ cheque, lang, tError, reload }) {
  if (cheque.status === "paid") {
    await revertChequePaid({ cheque, lang, tError, reload });
    return;
  }
  const q = lang === "ar"
    ? `هل فعلاً تم دفع هذا الشيك؟\n${Number(cheque.amount).toFixed(0)} ${cheque.currency}\n\nملاحظة: يمكنك التراجع لاحقًا بضغطة أخرى مع تأكيدات صارمة.`
    : `Confirm this cheque has been paid?\n${Number(cheque.amount).toFixed(0)} ${cheque.currency}\n\nYou can revert later with two confirmations.`;
  if (!window.confirm(q)) return;
  await payChequeWithGuard({ cheque, tError, reload });
}

export async function revertChequePaid({ cheque, lang, tError, reload }) {
  const q1 = lang === "ar" ? `هل أنت متأكد من التراجع عن دفع هذا الشيك؟\n${Number(cheque.amount).toFixed(0)} ${cheque.currency}` : `Are you sure you want to revert this cheque to unpaid?`;
  if (!window.confirm(q1)) return;
  const need = lang === "ar" ? "متأكد" : "REVERT";
  const q2 = lang === "ar"
    ? `تأكيد نهائي: اكتب كلمة "${need}" للتأكيد بأن الشيك لم يُدفع فعلاً.\nملاحظة مهمة: التحويلات بين حساباتك ستبقى كما هي، فقط سيُلغى خصم الشيك من الحساب المرتبط.`
    : `Final confirmation: type "${need}" to confirm the cheque was NOT paid.\nNote: transfers between your accounts stay intact, only the cheque deduction is undone.`;
  const answer = window.prompt(q2);
  if (!answer || answer.trim().toLowerCase() !== need.toLowerCase()) {
    if (answer !== null) toast.error(lang === "ar" ? "لم يتم تأكيد الكلمة." : "Word did not match.");
    return;
  }
  try { await api.patch(`/cheques/${cheque.id}`, { status: "pending" }); reload(); toast.success(lang === "ar" ? "تم إرجاع الشيك إلى غير مدفوع." : "Reverted."); }
  catch { toast.error(tError); }
}

export async function payWithTransfer(cheque, sourceAccountId, reload, tError) {
  try {
    await api.post(`/cheques/${cheque.id}/pay-with-transfer`, { source_account_id: sourceAccountId });
    reload();
    return true;
  } catch (e) {
    toast.error(e?.response?.data?.detail?.insufficient_source ? (tError + " (المصدر غير كافٍ)") : tError);
    return false;
  }
}
